import { render, staticRenderFns } from "./ActiveBonus.vue?vue&type=template&id=3d3d2f11&scoped=true"
import script from "./ActiveBonus.vue?vue&type=script&lang=js"
export * from "./ActiveBonus.vue?vue&type=script&lang=js"
import style0 from "./ActiveBonus.vue?vue&type=style&index=0&id=3d3d2f11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3d2f11",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default})
